<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.css.danger-text {
  color: #f22525 !important;
}

#simbart-coze-float-btn {
  position: fixed !important;
  top: 50% !important;
  right: 20px !important;
  transform: translateY(-50%) !important;
  z-index: 10001 !important;
  width: 56px !important;
  height: 56px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  background-color: transparent !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  cursor: pointer !important;
}

#simbart-coze-float-btn.is-hidden,
body.coze-chat-open #simbart-coze-float-btn {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

#simbart-coze-float-btn:hover {
  opacity: 0.92 !important;
}

#simbart-coze-float-btn:active {
  transform: translateY(-50%) scale(0.96) !important;
}

.coze-floating-button,
[class*='coze-floating'] {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue